export default function(menuItem, companyId, appBase) {
	let link = menuItem.itemValue;
	let base = link;
	let query = '';
	let pathParts;
	let searchParams;

	if (menuItem.linkType === 2) {
		link = link.replace('{companyId}', companyId);

		if (appBase) {
			if (appBase.endsWith('/')) {
				appBase = appBase.substring(0, appBase.length - 1);
			}
		} else {
			appBase = '';
		}

		link = `${appBase}${link}`;
	} else {
		pathParts = link.split('?');

		if (pathParts.length > 1) {
			base = pathParts[0];
			query = pathParts[1];
		}

		searchParams = new URLSearchParams(query);
		searchParams.append('cid', companyId);
		query = searchParams.toString();
		link = `${base}?${query}`;
	}

	return link;
}
